module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurLarge/Barry-S2.cd15b12.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurLarge/Barry-S2.jpg
// module id = k1/A
// module chunks = 0